import React, { useContext } from "react";
import { UserContext } from "../../../../UserContext";
import welcomeMountainImage from "../../../../assets/welcomeMountainImage.png";
import stoImg from "../../../../assets/stoImg.png";
import { ChevronRight } from "lucide-react";

const WelcomeIntroSection = ({ onNext }) => {
  const { user } = useContext(UserContext);
  const userName = user?.firstName || "there";

  const handleStartClick = () => {
    // Call parent's onNext if provided, otherwise do nothing
    if (onNext) {
      onNext();
    }
  };

  return (
    <section className="relative w-full h-full max-h-[90vh] overflow-hidden bg-white font-gotham">
      {/* Main Content */}
      <div className="relative z-10 mx-auto max-w-7xl min-h-screen h-full px-0 py-16 md:py-24">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 relative">
          
          {/* Left Content */}
          <div className="max-w-xl pl-5">
            <h1 className="text-3xl font-normal font-gotham text-black md:text-[40px]">
              Welcome, {userName}!
            </h1>

            <p className="mt-5 text-base md:text-[20px] text-[#323232] font-gotham font-normal leading-7 md:text-lg">
              I'm Sto, and I'll be guiding you through your learning path—helping
              you build the right skills, habits, and confidence as you grow.
              Up next, you'll meet others who will mentor, challenge, and support
              you at different stages of your journey.
              <br/>
            </p>

            {/* CTA Button */}
            <button 
              onClick={handleStartClick} 
              className="mt-8 inline-flex items-center gap-3 rounded-[22px] bg-[#54B0AF] hover:bg-teal-600 px-7 py-3 text-white transition hover:opacity-90"
            >
              <span className="text-base font-medium text-[21px] font-gotham">Let's get started</span>
              <span className="bg-white rounded-full p-2">
                <ChevronRight className="w-4 h-4 text-black" />
              </span>
            </button>
          </div>

          {/* Right Character Image */}
          <div className="flex justify-center md:justify-end absolute right-[5%] top-[20%]">
            <div className="relative h-[350px] w-[240px] md:h-[700px] md:w-[380px]">
              <img
                src={stoImg}
                alt="Sto Character"
                className="absolute bottom-0 h-full w-auto object-contain scale-x-[-1]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Background Illustration */}
      <div className="pointer-events-none absolute bottom-0 left-0 w-full">
        <div className="h-[150px] w-full md:h-[380px]">
          <img
            src={welcomeMountainImage}
            alt="Background Mountain Illustration"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default WelcomeIntroSection;